import React, { useState } from "react";
import GlobalStyles from "../../global/GlobalStyles";
import image from "../../assets/images/user.png";
import api from "../../global/api";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const ProfileDetailsCard = ({ user, personal, setLoading }) => {
  const [editPassword, setEditPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const data = {
    password,
    password_confirmation: confirmPassword,
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      const response = await api.put(`/users/${user.id}/password`, data);
      toast.success(response.data.message);
      setEditPassword(false);
      setConfirmPassword("");
      setPassword("");
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteUser = async () => {
    setLoading(true);
    try {
      const response = await api.delete(`/users/${user.id}/destroy`);
      toast.success(response.data.message);
      navigate(personal ? "/" : -1);
    } catch (error) {
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={GlobalStyles.sectionWrap}>
      <div className="w-full flex flex-col items-center gap-5">
        <img
          src={image}
          alt=""
          className="w-24 h-24 bg-primary/20 rounded-full"
        />
        {!editPassword && (
          <div className="flex flex-col w-full">
            <div className={GlobalStyles.seperator2}>
              <span className={GlobalStyles.textOrder}>Name:</span>
              <span className={`capitalize ${GlobalStyles.textOrder}`}>
                {user.name}
              </span>
            </div>
            <div className={GlobalStyles.seperator2}>
              <span className={GlobalStyles.textOrder}>Email:</span>
              <span className={`${GlobalStyles.textOrder}`}>{user.email}</span>
            </div>
            <div className={GlobalStyles.seperator2}>
              <span className={GlobalStyles.textOrder}>
                Account created on:
              </span>
              <span className={`capitalize ${GlobalStyles.textOrder}`}>
                {new Date(user.created_at).toLocaleDateString()}
              </span>
            </div>
          </div>
        )}
        {editPassword && (
          <form onSubmit={handleEdit} className="flex flex-col gap-5 w-full">
            <input
              placeholder="Password"
              className={GlobalStyles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
            />
            <input
              placeholder="Confirm password"
              className={GlobalStyles.input}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
            />
            <div className={`!flex-row-reverse ${GlobalStyles.seperator}`}>
              <div
                onClick={() => setShowPassword(!showPassword)}
                className={`${GlobalStyles.formLink} cursor-pointer`}
              >
                {showPassword ? "Hide password" : "Show password"}
              </div>
            </div>
            <button className={GlobalStyles.buttonFull}>Edit</button>
          </form>
        )}
        {personal && !editPassword && (
          <button
            onClick={() => setEditPassword(true)}
            className={GlobalStyles.buttonFullAlt}
          >
            Edit password
          </button>
        )}
        {editPassword ? (
          <button
            onClick={() => setEditPassword(false)}
            className={GlobalStyles.buttonFullAlt}
          >
            Cancel
          </button>
        ) : (
          <button onClick={deleteUser} className={GlobalStyles.buttonFull}>
            Delete account
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileDetailsCard;
